import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DEFAULT_LAYERS, DEFAULT_OPACITY_MAX, DEFAULT_OPACITY_MIN, } from "@erikwatson/snowfall";
import { Control } from "../../../control/control";
import { useDispatch } from "react-redux";
import { Range } from "../../../range/range";
import { setOpacityMax, setOpacityMin, } from "../../../../features/config/config.slice";
import { ControlGroup } from "../../../controlGroup/controlGroup";
import { Group } from "../../../group/group";
export const SnowflakeOpacity = ({ index, layer }) => {
    const dispatch = useDispatch();
    return (_jsx(_Fragment, { children: _jsx(Group, { colour: "grey-2", name: "Opacity", children: _jsxs(ControlGroup, { children: [_jsx(Control, { name: "Minimum", tooltip: "The minimum opacity of the snowflakes", showOutput: true, reset: () => {
                            const min = index < DEFAULT_LAYERS.length
                                ? DEFAULT_LAYERS[index].opacity.min
                                : DEFAULT_OPACITY_MIN;
                            dispatch(setOpacityMin({
                                index,
                                min,
                            }));
                        }, value: layer.opacity.min, onChange: (event) => dispatch(setOpacityMin({
                            index,
                            min: Number(event.target.value),
                        })), children: _jsx(Range, { min: "0", max: "1", step: "0.01" }) }), _jsx(Control, { name: "Maximum", tooltip: "The maximum opacity of the snowflakes", showOutput: true, reset: () => {
                            const max = index < DEFAULT_LAYERS.length
                                ? DEFAULT_LAYERS[index].opacity.max
                                : DEFAULT_OPACITY_MAX;
                            dispatch(setOpacityMax({
                                index,
                                max,
                            }));
                        }, value: layer.opacity.max, onChange: (event) => dispatch(setOpacityMax({
                            index,
                            max: Number(event.target.value),
                        })), children: _jsx(Range, { min: "0", max: "1", step: "0.01" }) })] }) }, index) }));
};
